/**
 * GA4 + Meta Pixel e-commerce analytics helpers.
 * GA4 via window.gtag, Meta Pixel via window.fbq.
 */

function gtag(...args) {
  if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
    window.gtag(...args);
  }
}

function fbq(...args) {
  if (typeof window !== 'undefined' && typeof window.fbq === 'function') {
    window.fbq(...args);
  }
}

function mapItems(items) {
  return (items || []).map((item, idx) => ({
    item_id: item.product_id || item.id || item._id,
    item_name: item.product_title || item.title,
    price: Number(item.price) || 0,
    quantity: item.quantity || 1,
    index: idx,
  }));
}

// ── ViewContent (Product Detail) ──
export function trackViewContent(product) {
  if (!product) return;
  const id = product._id || product.id;
  const value = Number(product.price) || 0;

  gtag('event', 'view_item', {
    currency: 'MXN',
    value,
    items: [{ item_id: id, item_name: product.title, price: value }],
  });

  fbq('track', 'ViewContent', {
    content_ids: [id],
    content_name: product.title,
    content_type: 'product',
    value,
    currency: 'MXN',
  });
}

// ── AddToCart ──
export function trackAddToCart(product, quantity) {
  if (!product) return;
  const id = product._id || product.id;
  const value = Number(product.price) || 0;

  gtag('event', 'add_to_cart', {
    currency: 'MXN',
    value,
    items: [{ item_id: id, item_name: product.title, price: value, quantity: quantity || 1 }],
  });

  fbq('track', 'AddToCart', {
    content_ids: [id],
    content_name: product.title,
    content_type: 'product',
    value,
    currency: 'MXN',
  });
}

// ── InitiateCheckout ──
export function trackBeginCheckout(cart, total) {
  const value = Number(total) || 0;
  const items = mapItems(cart);

  gtag('event', 'begin_checkout', {
    currency: 'MXN',
    value,
    items,
  });

  fbq('track', 'InitiateCheckout', {
    value,
    currency: 'MXN',
    num_items: cart.length,
    content_ids: items.map(i => i.item_id),
  });
}

// ── AddShippingInfo ──
export function trackAddShippingInfo(cart, total) {
  const value = Number(total) || 0;

  gtag('event', 'add_shipping_info', {
    currency: 'MXN',
    value,
    shipping_tier: 'standard',
    items: mapItems(cart),
  });
}

// ── AddPaymentInfo ──
export function trackAddPaymentInfo(cart, total, paymentMethod) {
  const value = Number(total) || 0;

  gtag('event', 'add_payment_info', {
    currency: 'MXN',
    value,
    payment_type: paymentMethod,
    items: mapItems(cart),
  });

  fbq('track', 'AddPaymentInfo', {
    value,
    currency: 'MXN',
  });
}

// ── Purchase ──
export function trackPurchase(order) {
  const items = (order.items || []).map((item, idx) => ({
    item_id: item.product_id,
    item_name: item.product_title,
    price: Number(item.price) || 0,
    quantity: item.quantity || 1,
    index: idx,
  }));

  const value = parseFloat(order.total) || 0;

  gtag('event', 'purchase', {
    transaction_id: order.order_id || order.id,
    value,
    currency: 'MXN',
    tax: 0,
    shipping: 0,
    items,
  });

  fbq('track', 'Purchase', {
    value,
    currency: 'MXN',
    content_ids: items.map(i => i.item_id),
    content_type: 'product',
    num_items: items.length,
  });
}
